import { lazy, Suspense } from "react";
import { PageSkeleton } from "../../customs/skeleton/main";
const Main = lazy(() => import("../../components/settings/branchSetup/main"));

const BranchSetup = () => {
  return (
      <Suspense fallback={<PageSkeleton />}>
        <Main />
      </Suspense>
  );
};

export default BranchSetup;
